<div id="privacy" fxLayout="column" fusePerfectScrollbar>

  <div id="privacy-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

    <div id="privacy-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
  <h1>
    {{'privacyInfo' | translate}}
  </h1>
      <div [innerHTML]="text">

      </div>
      <div class="confirm">
        <button mat-raised-button
                class="save-product-button mat-white-bg mt-16 mt-sm-0"
                (click)="confirm()">
          <span>{{'main.confirm' | translate}}</span>
        </button>
      </div>

    </div>


  </div>

</div>
